import React from "react";
import { useDispatch } from "react-redux";
import { StringParam, useQueryParam } from "use-query-params";

import { resetPassword } from "Auth/state";
import { AUTH_ACTIONS, IChangePassword } from "Auth/types";
import { ChangePassword as ChangePasswordComponent } from "Auth/components";
import { copy } from "shared/assets";

interface ChangePasswordProps {
  handleClose: () => void;
}

export const PasswordReset: React.FC<ChangePasswordProps> = ({ handleClose }) => {
  const dispatch = useDispatch();
  const [email] = useQueryParam("email", StringParam);
  const [code] = useQueryParam("code", StringParam);

  const onSubmit = ({ newPassword: password }: IChangePassword) => {
    if (code && email) {
      dispatch(resetPassword({ password, code, email }));
    }
  };

  return (
    <ChangePasswordComponent
      title={copy.passwordReset.title}
      handleClose={handleClose}
      onSubmit={onSubmit}
      metaKey={AUTH_ACTIONS.resetPassword}
    />
  );
};
